<template>
  <v-container id="alerts" fluid tag="section">
    <div class="text-right">
      <loading :active.sync="isLoading" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="fullPage" />
    </div>
    <v-row>
      <v-col cols="4">
        <v-select v-model="form.company" label="Company Name" :items="companyOptions" item-text="text"
          item-value="value" dense clearable />
      </v-col>
      <v-col cols="4">
        <v-menu ref="fromMenu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field v-model="form.startDate" label="From Date" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="form.startDate" :max="max" @input="fromMenu = false" />
        </v-menu>
      </v-col>

      <v-col cols="4">
        <v-menu ref="toMenu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field v-model="form.endDate" label="To Date" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="form.endDate" :max="max" @input="toMenu = false" />
        </v-menu>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="4">
        <v-btn small color="primary" @click="search">Search</v-btn>
        <v-btn small color="primary" @click="exportSearchData">Export</v-btn>
      </v-col>
    </v-row>
<v-row v-if="form.company !== 'All' && hasCompanyData" class="ml-1 mt-3">
  <v-col cols="3">
    <strong>Total logins:</strong> {{ totalLogins }}
  </v-col>
  <v-col cols="3">
    <strong>Total hours:</strong> {{ totalHours }}
  </v-col>
  <v-col cols="3">
    <strong>Total minutes:</strong> {{ totalMinutes }}
  </v-col>
  <v-col cols="3">
    <strong>Total seconds:</strong> {{ totalSeconds }}
  </v-col>
</v-row>




    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          item-key="userID"
          :items-per-page="-1"
          class="elevation-1"
          hide-default-footer
          ref="dataTable"
        >
          <template v-slot:item.queryDate="{ item }">
            <div class="align-top-cell">
              {{ formatDate(item.queryDate) }}
            </div>
          </template>

          <template v-slot:item.searchCriteria="{ item }">
            <div v-html="item.searchCriteria"></div>
          </template>

          <template v-slot:item.total_download="{ item }">
            <div class="align-top-cell">
              {{ item.total_download || 0 }}
            </div>
          </template>

          <template v-slot:item.mediaChannel="{ item }">
            <div v-if="item.mediaChannel && item.mediaChannel.length">
              <v-chip v-for="(channel, index) in item.mediaChannel.slice(0, 3)" :key="index" small class="ma-1">
                {{ channel }}
              </v-chip>
              <span v-if="item.mediaChannel.length > 3" class="text-caption">
                +{{ item.mediaChannel.length - 3 }} more
              </span>
            </div>
            <span v-else>N/A</span>
          </template>

          <template v-slot:item.sector="{ item }">
            <div v-if="item.sector && item.sector.length">
              <v-chip v-for="(sec, index) in item.sector.slice(0, 2)" :key="index" small class="ma-1">
                {{ sec }}
              </v-chip>
              <span v-if="item.sector.length > 2" class="text-caption">
                +{{ item.sector.length - 2 }} more
              </span>
            </div>
            <span v-else>N/A</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon medium color="grey" @click="updateUser(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <div ref="scrollTarget" style="height: 20px"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Pagination from "./component/Pagination.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  name: "TrendReport",
  components: { Loading, Pagination },
  data: () => ({
    company: null,
    hasCompanyData: false,

    totalLogins: 0,
totalHours: 0,
totalMinutes: 0,
totalSeconds: 0,

    userSuggestions: [],
    companyOptions: [],
    isUserLoading: false,
    dateValidationDialog: false,
    validationMessage: '',
    username: '',
    userEmail: '',
    searchQuery: '',
    companyName: '',
    userSearchTimer: null,
    fromMenu: false,
    toMenu: false,
 page: 1,
  perpage: 20,
    totRecords: 0,
    pageCount: 0,
    headers: [
      { text: "Name", value: "name", width: "45%", align: 'center' },
      { text: "Logins", value: "searchCriteria", sortable: false, width: "10%" },
      { text: "Hours", value: "hours", sortable: false, width: "10%" },
      { text: "Minutes", value: "minutes", sortable: false, width: "10%" },
      { text: "Seconds", value: "seconds", sortable: false, width: "10%" },
    ],
    form: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      company: null,
    },
    items: [],
    isLoading: false,
    fullPage: true,
    max: moment(new Date()).format("YYYY-MM-DD"),
    scrollObserver: null,
    isFetchingMore: false,
  }),
  methods: {
    async exportSearchData() {
      this.isLoading = true;
      const url = this.$url("USER_TRACKING");
      const queryParams = {
        from_date: this.form.startDate,
        to_date: this.form.endDate,
        export: 1,
      };
      if (this.form.company && this.form.company !== 'All') {
        queryParams.company_name = this.form.company;
      }
      try {
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
          responseType: 'blob',
        }).get(url, { params: queryParams });

        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const urlBlob = URL.createObjectURL(blob);
        link.href = urlBlob;
        link.setAttribute('download', `User_Tracking_Report_${moment().format('YYYYMMDD_HHmmss')}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(urlBlob);
      } catch (error) {
        console.error("Error exporting data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchCompanyList() {
      this.isLoading = true;
      try {
        const url = this.$url("COMPANY_LIST");
        const response = await this.$fetch({ requiresAuth: true, operation: "view", vueScope: this }).get(url);
        const companies = response.data?.data || [];
        this.companyOptions = [
          { text: "All", value: "All" },
          ...companies.map(name => ({ text: name, value: name }))
        ];
        this.form.company = "All";
      } catch (error) {
        console.error("Error fetching company list:", error);
        this.companyOptions = [{ text: "All", value: "All" }];
        this.form.company = "All";
      } finally {
        this.isLoading = false;
      }
    },
async fetchUserTrackingData() {
  this.isLoading = true;
  if (this.isLoading && this.isFetchingMore) return;

  this.isFetchingMore = true;

  const url = this.$url("USER_TRACKING");
  const queryParams = {
    from_date: this.form.startDate,
    to_date: this.form.endDate,
    page: this.page,
    limit: this.perpage,
  };

  if (this.form.company && this.form.company !== "All") {
    queryParams.company_name = this.form.company;
  }

  try {
    const response = await this.$fetch({
      requiresAuth: true,
      operation: "view",
      vueScope: this,
    }).get(url, { params: queryParams });

    // If API returns with no data
    if (!response.data?.data || !Array.isArray(response.data.data?.tracker_data)) {
      this.totalLogins = 0;
      this.totalHours = 0;
      this.totalMinutes = 0;
      this.totalSeconds = 0;
      this.hasCompanyData = false;
      this.items = [];
      this.totRecords = 0;
      this.pageCount = 0;
      this.isLoading = false;
      return;
    }

    const result = response.data.data;

    // Map new items
    const newItems = result.tracker_data.map((entry) => ({
      name: entry.name || "N/A",
      searchCriteria: entry.logins || 0,
      total_download: entry.logins || 0,
      hours: entry.hours || 0,
      minutes: entry.minutes || 0,
      seconds: entry.seconds || 0,
    }));

    // Append new data
    this.items = [...this.items, ...newItems];

    // Pagination info
    this.totRecords = result.pagination?.total_count || this.items.length;
    this.pageCount = Math.ceil(this.totRecords / this.perpage);

    // Totals info
    if (result.company_data) {
      this.totalLogins = result.company_data.total_logins || 0;
      this.totalHours = result.company_data.hours || 0;
      this.totalMinutes = result.company_data.minutes || 0;
      this.totalSeconds = result.company_data.seconds || 0;
      this.hasCompanyData = true;
    } else {
      this.hasCompanyData = false;
    }

  } catch (error) {
    console.error("Error fetching user tracking data:", error);
    this.hasCompanyData = false;
  } finally {
    this.isLoading = false;
    this.isFetchingMore = false;
  }
},


    formatDate(date) {
      if (!date) return 'N/A';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
search() {
  this.page = 1;
  this.items = [];
  this.fetchUserTrackingData();
},


    updateUser(item) {
      console.log("Update user", item);
    },
  },
mounted() {
  this.fetchCompanyList();
  const target = this.$refs.scrollTarget;
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 1.0,
  };

  this.scrollObserver = new IntersectionObserver(async (entries) => {
    const entry = entries[0];
    if (
      entry.isIntersecting &&
      this.items.length < this.totRecords &&
      !this.isFetchingMore
    ) {
      this.page += 1;
      await this.fetchUserTrackingData();
    }
  }, options);

  if (target) {
    this.scrollObserver.observe(target);
  }
},



  beforeUnmount() {
    if (this.scrollObserver) this.scrollObserver.disconnect();
  },
};
</script>
<style scoped>
.search-padding {
  padding: 0px !important;
}

#required {
  color: red;
}

#approved {
  color: red;
}

.custom-input {
  padding-top: 22px !important;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.menu-position {
  min-width: auto;
  top: 340px !important;
  transform-origin: left top;
  z-index: 204;
}

.search-criteria {
  line-height: 1.6;
  font-size: 14px;
}

.search-criteria strong {
  color: #2c3e50;
}

.align-top-cell {
  display: flex;
  align-items: flex-start !important;
  justify-content: center !important;
  height: 100%;
}

.active-page {
  background-color: #1976d2;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
}

.notactivespan {
  color: #666;
  cursor: pointer;
}
</style>